<div
  class="min-h-dvh bg-[#F3F4F6] text-[#24324A] lg:grid"
  [ngClass]="sidebarCollapsed ? 'lg:grid-cols-[82px_minmax(0,1fr)]' : 'lg:grid-cols-[292px_minmax(0,1fr)]'"
  [style.--backoffice-sidebar-width]="sidebarCollapsed ? '82px' : '292px'"
>
  <aside
    class="backoffice-sidebar fixed inset-y-0 left-0 z-40 flex h-dvh w-[min(292px,calc(100vw-56px))] min-h-0 -translate-x-full flex-col overflow-hidden bg-white px-5 pb-6 pt-7 shadow-[12px_0_30px_rgba(15,23,42,0.08)] transition-[transform,width,padding] duration-200 lg:top-0 lg:translate-x-0 lg:shadow-none"
    [ngClass]="sidebarCollapsed ? 'lg:w-[82px] lg:px-4' : 'lg:w-[292px] lg:px-6'"
    [class.translate-x-0]="sidebarOpen"
    [attr.aria-label]="'header.backofficeNavigation' | t"
  >
    <div
      class="backoffice-sidebar__workspace -mx-5 mb-5 shrink-0 border-b border-[#D8E3EA] px-5 pb-6 lg:-mx-6 lg:px-6"
      data-backoffice-workspace-menu
      [class.lg:mx-0]="sidebarCollapsed"
      [class.lg:border-b-0]="sidebarCollapsed"
      [class.lg:px-0]="sidebarCollapsed"
      [class.lg:pb-4]="sidebarCollapsed"
    >
      @if (!workspaceLoading) {
        <div class="mb-7" [class.lg:hidden]="sidebarCollapsed">
          <h2 class="m-0 truncate text-[26px] font-extrabold leading-[1.08] tracking-[-0.035em] text-[var(--workspace-primary)]">
            {{ workspaceName }}
          </h2>
          <p class="backoffice-sidebar__role m-0 mt-2 truncate text-[15px] font-medium leading-5 text-[#374151]">
            {{ activeWorkspaceRole }}
          </p>
        </div>
      } @else {
        <div class="mb-7 grid gap-2" [class.lg:hidden]="sidebarCollapsed" aria-hidden="true">
          <span class="h-8 w-[78%] animate-pulse rounded-full bg-[#E6EEF3]"></span>
          <span class="h-5 w-[58%] animate-pulse rounded-full bg-[#EEF4F7]"></span>
        </div>
      }

      <div class="workspace-switch relative" [class.lg:flex]="sidebarCollapsed" [class.lg:justify-center]="sidebarCollapsed">
        <button
          type="button"
          class="workspace-switch__trigger group grid w-full cursor-pointer items-center rounded-xl border border-[#BDD5E1] bg-[#F8FBFD] p-1 text-left transition focus:outline-none focus:ring-2 focus:ring-[color-mix(in_srgb,var(--workspace-primary)_24%,transparent)]"
          [ngClass]="sidebarCollapsed ? 'lg:h-12.5 lg:w-12.5 lg:grid-cols-1 lg:place-items-center lg:rounded-2xl lg:p-2' : 'grid-cols-[52px_minmax(0,1fr)_20px]'"
          [attr.aria-expanded]="workspaceMenuOpen"
          [attr.aria-label]="'header.switchWorkspace' | t"
          [disabled]="workspaceLoading || (workspaceOptions.length <= 1 && !canCreateOrganization)"
          (click)="toggleWorkspaceMenu()"
        >
          <span
            class="workspace-switch__icon grid h-8.75 w-8.75 shrink-0 place-items-center overflow-hidden rounded-[10px] text-white shadow-[0_10px_22px_rgba(23,109,134,0.18)]"
            [class.workspace-switch__icon--logo]="!workspaceLoading && !!workspaceLogoUrl"
            [class.workspace-switch__icon--initials]="!workspaceLoading && !workspaceLogoUrl && !!workspaceName"
          >
            @if (workspaceLoading) {
              <span class="h-6 w-6 animate-spin rounded-full border-2 border-white/40 border-t-white" aria-hidden="true"></span>
            } @else if (workspaceLogoUrl) {
              <img
                [src]="workspaceLogoUrl"
                [alt]="workspaceName || ('header.organization' | t)"
                (error)="handleWorkspaceLogoError()"
              />
            } @else if (workspaceName) {
              <span class="workspace-switch__initials" aria-hidden="true">{{ workspaceInitials(workspaceName) }}</span>
            } @else {
              <span class="material-symbols-outlined text-[27px] leading-none" aria-hidden="true">business</span>
            }
          </span>
          <span class="min-w-0" [class.lg:hidden]="sidebarCollapsed">
            <span class="workspace-switch__eyebrow block truncate text-[12px] font-bold uppercase leading-4 tracking-[0.16em]">{{ 'header.organization' | t }}</span>
            @if (!workspaceLoading) {
              <span class="workspace-switch__name mt-1 block truncate text-[13px] font-bold leading-6 tracking-[-0.035em] text-[#101828]">{{ workspaceName }}</span>
            } @else {
              <span class="mt-2 block h-5 w-[82%] animate-pulse rounded-full bg-[#E6EEF3]" aria-hidden="true"></span>
            }
          </span>
          @if (!workspaceLoading && (workspaceOptions.length > 1 || canCreateOrganization)) {
            <span
              class="workspace-switch__chevrons grid gap-0 transition"
              [class.lg:hidden]="sidebarCollapsed"
              aria-hidden="true"
            >
              <span class="material-symbols-outlined mb-1 text-[22px] leading-none">keyboard_arrow_up</span>
              <span class="material-symbols-outlined -mt-2 text-[22px] leading-none">keyboard_arrow_down</span>
            </span>
          }
        </button>

        @if (workspaceMenuOpen && !sidebarCollapsed) {
          <div
            class="workspace-switch__menu absolute left-0 right-0 top-[calc(100%+10px)] z-50 overflow-hidden rounded-[18px] border border-[#BFD7E4] bg-white p-2 shadow-[0_24px_60px_rgba(15,23,42,0.20)]"
            role="menu"
          >
            <p class="workspace-switch__menu-title m-0 border-b border-[#EEF2F6] px-3 pb-2.5 pt-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-[#98A2B3]">{{ 'header.switchWorkspace' | t }}</p>
            <div class="workspace-switch__menu-list mt-2 grid gap-1">
              @for (organization of workspaceOptions; track organization.orgId) {
                <button
                  type="button"
                  class="workspace-switch__menu-item grid w-full cursor-pointer grid-cols-[40px_minmax(0,1fr)_20px] items-center gap-3 rounded-[13px] border-0 bg-transparent px-2.5 py-2.5 text-left transition"
                  [class.workspace-switch__menu-item--active]="organization.orgId === activeWorkspaceId"
                  role="menuitem"
                  (click)="switchWorkspace(organization)"
                >
                  <span class="workspace-switch__avatar grid h-10 w-10 place-items-center rounded-[11px] text-[12px] font-extrabold">
                    {{ workspaceInitials(organization.orgName) }}
                  </span>
                  <span class="min-w-0">
                    <span class="workspace-switch__item-name block truncate text-[14px] font-bold text-[#101828]">{{ organization.orgName }}</span>
                    <span
                      class="workspace-switch__item-meta block truncate text-[11px]"
                      [ngClass]="workspaceIsInactive(organization) ? 'text-[#B45309]' : 'text-[#98A2B3]'"
                    >
                      {{ workspaceStateLabel(organization) }}
                    </span>
                  </span>
                  @if (organization.orgId === activeWorkspaceId) {
                    <span class="workspace-switch__check material-symbols-outlined text-[18px]" aria-hidden="true">check_circle</span>
                  }
                </button>
              }
            </div>
            @if (canCreateOrganization) {
              <div class="workspace-switch__menu-actions mt-2 border-t border-[#EEF2F6] pt-2">
                <button
                  type="button"
                  class="workspace-switch__create grid w-full cursor-pointer grid-cols-[40px_minmax(0,1fr)_20px] items-center gap-3 rounded-[13px] border-0 bg-transparent px-2.5 py-2.5 text-left transition"
                  role="menuitem"
                  (click)="createOrganization()"
                >
                  <span class="workspace-switch__create-icon material-symbols-outlined grid h-10 w-10 place-items-center rounded-[11px] text-[20px]" aria-hidden="true">add_business</span>
                  <span class="min-w-0">
                    <span class="workspace-switch__item-name block truncate text-[14px] font-bold text-[#101828]">{{ 'header.createOrganization' | t }}</span>
                    <span class="workspace-switch__item-meta block truncate text-[11px]">{{ 'header.createOrganizationHint' | t }}</span>
                  </span>
                  <span class="workspace-switch__check material-symbols-outlined text-[18px]" aria-hidden="true">arrow_forward</span>
                </button>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <app-scroll-navigation class="min-h-0 flex-1">
    <nav class="backoffice-sidebar__primary grid content-start gap-2 pr-1" [attr.aria-label]="'header.primaryNavigation' | t">
      @for (item of primaryNav; track item.labelKey) {
        @if (item.children?.length && !item.disabled) {
          <div class="nav-group grid gap-1">
            <button
              class="backoffice-nav-item group grid min-h-[40px] w-full cursor-pointer items-center gap-3 rounded-[8px] border-0 bg-transparent px-3 text-left font-normal transition"
              [ngClass]="[
                sidebarCollapsed ? 'lg:grid-cols-[20px] lg:justify-center' : 'grid-cols-[20px_minmax(0,1fr)_14px]',
                navItemIsActive(item) ? 'backoffice-nav-item--active' : 'backoffice-nav-item--inactive'
              ]"
              type="button"
              [attr.aria-current]="navItemIsActive(item) ? 'page' : null"
              [attr.aria-expanded]="navGroupIsExpanded(item)"
              (click)="toggleNavGroup(item)"
            >
              <span
                class="material-symbols-outlined text-[20px] leading-none"
              >
                {{ item.icon }}
              </span>
              <span class="min-w-0 truncate font-['Inter'] text-[13px] font-normal not-italic leading-[19.5px]" [class.lg:hidden]="sidebarCollapsed">{{ item.labelKey | t }}</span>
              @if (!sidebarCollapsed) {
                <span class="material-symbols-outlined text-[18px] leading-none text-[var(--workspace-primary)]" aria-hidden="true">
                  {{ navGroupIsExpanded(item) ? 'keyboard_arrow_down' : 'chevron_right' }}
                </span>
              }
            </button>
            @if (!sidebarCollapsed && navGroupIsExpanded(item)) {
              <div class="nav-group__children grid gap-1">
                @for (child of item.children; track child.labelKey) {
                  @if (child.route && !child.disabled) {
                    <a
                      #childActiveLink="routerLinkActive"
                      class="nav-group__child grid min-h-[34px] grid-cols-[8px_minmax(0,1fr)] items-center gap-3 rounded-[8px] px-3 text-left font-normal no-underline transition"
                      [ngClass]="childActiveLink.isActive ? 'nav-group__child--active' : 'nav-group__child--inactive'"
                      [routerLink]="child.route"
                      [queryParams]="child.queryParams"
                      routerLinkActive
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="closeSidebar()"
                    >
                      <span class="nav-group__child-dot" aria-hidden="true"></span>
                      <span class="flex min-w-0 items-center gap-1.5">
                        <span class="min-w-0 truncate font-['Inter'] text-[12px] font-normal leading-[18px]">{{ child.labelKey | t }}</span>
                        @if (lockedByPlan(child)) {
                          <span class="nav-plan-lock material-symbols-outlined" [title]="'nav.notInPlan' | t: 'Not included in your plan'" aria-hidden="true">lock</span>
                          <span class="sr-only">{{ 'nav.notInPlan' | t: 'Not included in your plan' }}</span>
                        }
                      </span>
                    </a>
                  }
                }
              </div>
            }
          </div>
        } @else if (item.route && !item.disabled) {
          <a
            #activeLink="routerLinkActive"
            class="backoffice-nav-item group grid min-h-[40px] items-center gap-3 rounded-[8px] px-3 text-left font-normal no-underline transition"
            [ngClass]="[
              sidebarCollapsed ? 'grid-cols-[20px_minmax(0,1fr)_14px] lg:grid-cols-[20px] lg:justify-center' : 'grid-cols-[20px_minmax(0,1fr)_14px]',
              activeLink.isActive ? 'backoffice-nav-item--active' : 'backoffice-nav-item--inactive'
            ]"
            [routerLink]="item.route"
            [queryParams]="item.queryParams"
            routerLinkActive
            [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
            (click)="closeSidebar()"
          >
            @if (item.icon === 'documents_custom') {
              <span
                class="grid h-5 w-5 place-items-center leading-none"
                aria-hidden="true"
              >
                <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 5.58974C2 3.89752 2 3.05141 2.52571 2.52571C3.05141 2 3.89752 2 5.58974 2H10.4103C12.1025 2 12.9486 2 13.4743 2.52571C14 3.05141 14 3.89752 14 5.58974V10.4103C14 12.1025 14 12.9486 13.4743 13.4743C12.9486 14 12.1025 14 10.4103 14H5.58974C3.89752 14 3.05141 14 2.52571 13.4743C2 12.9486 2 12.1025 2 10.4103V5.58974Z" stroke="currentColor" stroke-width="1.33"/>
                  <path d="M2 4.66797H3.66667C4.42043 4.66797 4.79732 4.66797 5.13057 4.80785C5.20368 4.83854 5.27467 4.87403 5.34308 4.91411C5.65494 5.09678 5.88107 5.39829 6.33333 6.0013C6.78559 6.60432 7.01172 6.90582 7.32358 7.0885C7.392 7.12857 7.46299 7.16407 7.53609 7.19475C7.86935 7.33464 8.24623 7.33464 9 7.33464H12C12.1905 7.33464 12.2857 7.33464 12.366 7.32741C13.2302 7.24963 13.915 6.56482 13.9928 5.70065C14 5.62037 14 5.52513 14 5.33464" stroke="currentColor" stroke-width="1.33"/>
                  <path d="M4.66699 10.668H10.0003" stroke="currentColor" stroke-width="1.33" stroke-linecap="round"/>
                </svg>
              </span>
            } @else {
              <span
                class="material-symbols-outlined text-[20px] leading-none"
              >
                {{ item.icon }}
              </span>
            }
            <span class="min-w-0 truncate font-['Inter'] text-[13px] font-normal not-italic leading-[19.5px]" [class.lg:hidden]="sidebarCollapsed">{{ item.labelKey | t }}</span>
            @if (activeLink.isActive && !sidebarCollapsed) {
              <span
                class="material-symbols-outlined text-[18px] leading-none text-[var(--workspace-primary)]"
                aria-hidden="true"
              >
                chevron_right
              </span>
            }
          </a>
        } @else {
          <button
            class="backoffice-nav-item backoffice-nav-item--inactive group grid min-h-[40px] w-full cursor-default grid-cols-[20px_minmax(0,1fr)] items-center gap-3 rounded-[8px] border-0 bg-transparent px-3 text-left font-normal"
            [ngClass]="sidebarCollapsed ? 'lg:grid-cols-[20px] lg:justify-center' : 'grid-cols-[20px_minmax(0,1fr)]'"
            type="button"
            disabled
          >
            @if (item.icon === 'documents_custom') {
              <span class="grid h-5 w-5 place-items-center leading-none" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 5.58974C2 3.89752 2 3.05141 2.52571 2.52571C3.05141 2 3.89752 2 5.58974 2H10.4103C12.1025 2 12.9486 2 13.4743 2.52571C14 3.05141 14 3.89752 14 5.58974V10.4103C14 12.1025 14 12.9486 13.4743 13.4743C12.9486 14 12.1025 14 10.4103 14H5.58974C3.89752 14 3.05141 14 2.52571 13.4743C2 12.9486 2 12.1025 2 10.4103V5.58974Z" stroke="currentColor" stroke-width="1.33"/>
                  <path d="M2 4.66797H3.66667C4.42043 4.66797 4.79732 4.66797 5.13057 4.80785C5.20368 4.83854 5.27467 4.87403 5.34308 4.91411C5.65494 5.09678 5.88107 5.39829 6.33333 6.0013C6.78559 6.60432 7.01172 6.90582 7.32358 7.0885C7.392 7.12857 7.46299 7.16407 7.53609 7.19475C7.86935 7.33464 8.24623 7.33464 9 7.33464H12C12.1905 7.33464 12.2857 7.33464 12.366 7.32741C13.2302 7.24963 13.915 6.56482 13.9928 5.70065C14 5.62037 14 5.52513 14 5.33464" stroke="currentColor" stroke-width="1.33"/>
                  <path d="M4.66699 10.668H10.0003" stroke="currentColor" stroke-width="1.33" stroke-linecap="round"/>
                </svg>
              </span>
            } @else {
              <span class="material-symbols-outlined text-[20px] leading-none">{{ item.icon }}</span>
            }
            <span class="min-w-0 truncate font-['Inter'] text-[13px] font-normal not-italic leading-[19.5px]" [class.lg:hidden]="sidebarCollapsed">{{ item.labelKey | t }}</span>
          </button>
        }
      }
    </nav>
    </app-scroll-navigation>

    <div class="backoffice-sidebar__footer mt-5 shrink-0">
      <nav class="grid gap-2" [attr.aria-label]="'header.supportNavigation' | t">
        @for (item of supportNav; track item.labelKey) {
          @if (item.action) {
            <button
              type="button"
              class="backoffice-nav-item backoffice-nav-item--inactive group grid min-h-[40px] w-full cursor-pointer items-center gap-3 rounded-[8px] border-0 bg-transparent px-3 text-left font-normal"
              [ngClass]="sidebarCollapsed ? 'grid-cols-[20px_minmax(0,1fr)] lg:grid-cols-[20px] lg:justify-center' : 'grid-cols-[20px_minmax(0,1fr)]'"
              [attr.title]="item.labelKey | t"
              data-setup-guide-reopen
              (click)="runSupportAction(item)"
            >
              <span class="material-symbols-outlined text-[20px] leading-none" aria-hidden="true">{{ item.icon }}</span>
              <span class="min-w-0 truncate font-['Inter'] text-[13px] font-normal not-italic leading-[19.5px]" [class.lg:hidden]="sidebarCollapsed">{{ item.labelKey | t }}</span>
            </button>
          } @else if (item.route && !item.disabled) {
            <a
              #supportActiveLink="routerLinkActive"
              class="backoffice-nav-item group grid min-h-[40px] items-center gap-3 rounded-[8px] px-3 text-left font-normal no-underline transition"
              [ngClass]="[
                sidebarCollapsed ? 'grid-cols-[20px_minmax(0,1fr)_14px] lg:grid-cols-[20px] lg:justify-center' : 'grid-cols-[20px_minmax(0,1fr)_14px]',
                supportActiveLink.isActive ? 'backoffice-nav-item--active' : 'backoffice-nav-item--inactive'
              ]"
              [routerLink]="item.route"
              [queryParams]="item.queryParams"
              routerLinkActive
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeSidebar()"
            >
              <span
                class="material-symbols-outlined text-[20px] leading-none"
              >
                {{ item.icon }}
              </span>
              <span class="min-w-0 truncate font-['Inter'] text-[13px] font-normal not-italic leading-[19.5px]" [class.lg:hidden]="sidebarCollapsed">{{ item.labelKey | t }}</span>
            </a>
          } @else {
            <button
              class="backoffice-nav-item backoffice-nav-item--inactive group grid min-h-[40px] w-full cursor-default grid-cols-[20px_minmax(0,1fr)] items-center gap-3 rounded-[8px] border-0 bg-transparent px-3 text-left font-normal"
              [ngClass]="sidebarCollapsed ? 'lg:grid-cols-[20px] lg:justify-center' : 'grid-cols-[20px_minmax(0,1fr)]'"
              type="button"
              disabled
            >
              <span class="material-symbols-outlined text-[20px] leading-none">{{ item.icon }}</span>
              <span class="min-w-0 truncate font-['Inter'] text-[13px] font-normal not-italic leading-[19.5px]" [class.lg:hidden]="sidebarCollapsed">{{ item.labelKey | t }}</span>
            </button>
          }
        }
      </nav>

      <div class="my-5 h-px bg-[var(--workspace-primary)]"></div>

      @let user = shellUser$ | async;
      <div
        class="backoffice-user-card grid w-full items-center gap-2"
        [ngClass]="sidebarCollapsed ? 'lg:grid-cols-[42px] lg:justify-center' : 'grid-cols-[minmax(0,1fr)_40px]'"
      >
        <button
          type="button"
          class="backoffice-user-card__profile grid min-w-0 cursor-pointer items-center gap-3 border-0 bg-transparent px-3 py-2 text-left"
          [ngClass]="sidebarCollapsed ? 'lg:grid-cols-[38px] lg:justify-center lg:px-0' : 'grid-cols-[38px_minmax(0,1fr)]'"
          [attr.aria-label]="'settings.profile' | t"
          (click)="openProfile()"
        >
          <div
            class="relative grid h-[38px] w-[38px] overflow-hidden rounded-full bg-[linear-gradient(135deg,#1e3a5f,#b54f47)] text-[12px] font-extrabold text-white"
            aria-hidden="true"
          >
            @if (user?.avatarUrl) {
              <img [src]="user?.avatarUrl" alt="" class="h-full w-full object-cover" />
            } @else if (!user?.identityLoaded) {
              <span class="place-self-center h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white"></span>
            } @else {
              <span class="place-self-center">{{ user?.initials }}</span>
            }
          </div>
          <div class="min-w-0" [class.lg:hidden]="sidebarCollapsed">
            @if (user?.identityLoaded) {
              <p class="m-0 truncate text-[13px] font-semibold text-[#111827]">
                {{ user?.displayName || (user?.profile?.email || user?.session?.email || '') }}
              </p>
              <span class="mt-0.5 block truncate text-[11px] text-[#536176]">
                {{ user?.profile?.email || user?.session?.email || ('common.signedIn' | t) }}
              </span>
            } @else {
              <span class="inline-flex items-center gap-2 text-[12px] font-semibold text-[#536176]">
                <span class="h-3.5 w-3.5 animate-spin rounded-full border-2 border-[color-mix(in_srgb,var(--workspace-primary)_30%,transparent)] border-t-[var(--workspace-primary)]"></span>
                {{ 'common.loading' | t }}
              </span>
            }
          </div>
        </button>
        <button
          type="button"
          class="backoffice-user-card__logout grid h-10 w-10 cursor-pointer place-items-center border-0 transition"
          [class.lg:hidden]="sidebarCollapsed"
          [attr.aria-label]="'common.logOut' | t"
          (click)="logout()"
        >
          <span class="material-symbols-outlined text-[22px] leading-none" aria-hidden="true">logout</span>
        </button>
      </div>
    </div>
  </aside>

  @if (sidebarOpen) {
    <button
      type="button"
      class="fixed inset-0 z-30 border-0 bg-slate-900/40 lg:hidden"
      [attr.aria-label]="'header.closeNavigation' | t"
      (click)="closeSidebar()"
    ></button>
  }

  <main class="min-h-dvh min-w-0 bg-[#F3F4F6] lg:col-start-2">
    <header
      class="sticky top-0 z-20 flex min-h-[76px] items-center justify-between gap-4 bg-white px-4 py-3 shadow-[0_10px_24px_rgba(15,23,42,0.08)] sm:px-5 lg:fixed lg:right-0 lg:px-6"
      [ngClass]="'lg:left-[var(--backoffice-sidebar-width)]'"
    >
      @let headerUser = shellUser$ | async;
      <div class="flex min-w-0 items-center gap-3">
        <button
          type="button"
          class="grid h-10 w-10 shrink-0 cursor-pointer place-items-center rounded-xl border-0 bg-transparent text-[var(--workspace-primary)] transition hover:bg-[color-mix(in_srgb,var(--workspace-primary)_7%,#ffffff)]"
          [attr.aria-label]="sidebarCollapsed ? ('header.expandNavigation' | t) : ('header.collapseNavigation' | t)"
          (click)="toggleNavigation()"
        >
          <span class="material-symbols-outlined text-[26px] leading-none" aria-hidden="true">menu</span>
        </button>
        <div class="backoffice-header-greeting min-w-0">
          @if (headerUser?.identityLoaded) {
            <h1 class="m-0 truncate text-[16px] font-bold leading-6 text-[#101828]">
              {{ greetingKey | t }}@if (headerUser?.displayName) {, {{ headerUser?.displayName }}}
            </h1>
          } @else {
            <div class="inline-flex items-center gap-2 text-[14px] font-semibold text-[#536176]">
              <span class="h-4 w-4 animate-spin rounded-full border-2 border-[color-mix(in_srgb,var(--workspace-primary)_30%,transparent)] border-t-[var(--workspace-primary)]"></span>
              {{ 'common.loading' | t }}
            </div>
          }
          <p class="m-0 hidden text-[13px] leading-5 text-[#8A8F98] sm:block">
            {{ currentDateLabel }}
          </p>
        </div>
      </div>

      <div class="backoffice-header-actions ml-auto flex min-w-0 items-center gap-3">
        <div *ngIf="canUseAi"
          class="ai-floating-chat"
          [class.ai-floating-chat--clear-footer]="shouldClearAiFooter"
          data-backoffice-ai-command
        >
          <button
            type="button"
            class="ai-floating-chat__launcher"
            [attr.aria-label]="'header.ai.title' | t"
            [attr.title]="'header.ai.title' | t"
            [attr.aria-expanded]="aiCommandMenuOpen"
            (click)="toggleAiCommandMenu()"
          >
            <img src="/assets/brand/fav.png" alt="" aria-hidden="true" />
          </button>

          @if (aiCommandMenuOpen) {
            <div class="ai-command-menu ai-chat-panel absolute bottom-[calc(100%+14px)] right-0 z-50 w-[min(760px,calc(100vw-32px))] overflow-hidden rounded-[16px] border shadow-[0_24px_60px_rgba(15,23,42,0.18)]">
              <div class="ai-command-menu__header ai-chat-panel__header border-b px-4 py-3">
                <div class="flex items-start justify-between gap-3">
                  <div class="flex min-w-0 items-start gap-3">
                    <span class="ai-chat-panel__mark material-symbols-outlined" aria-hidden="true">auto_awesome</span>
                    <div class="min-w-0">
                      <p class="m-0 text-[10px] font-bold uppercase tracking-[0.16em]">{{ 'header.ai.title' | t }}</p>
                      <span class="mt-1 block text-[12px] leading-5">{{ 'header.ai.subtitle' | t }}</span>
                    </div>
                  </div>
                  <div class="flex shrink-0 items-center gap-2">
                    @if (aiCommandLoading) {
                      <button type="button" class="ai-command-menu__clear" (click)="cancelAiResponse()">Cancel response</button>
                    }
                    @if (aiCommandMessages.length > 0) {
                      <button
                        type="button"
                        class="ai-command-menu__clear"
                        (click)="clearAiConversation()"
                      >
                        {{ 'header.ai.newChat' | t }}
                      </button>
                    }
                    <button
                      type="button"
                      class="ai-chat-panel__close"
                      (click)="closeAiConversation()"
                      [attr.aria-label]="'common.close' | t:'Close'"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">close</span>
                    </button>
                  </div>
                </div>
              </div>

              <div class="ai-chat-panel__body">
                <section #aiConversationScroll class="ai-chat-panel__conversation">
                  @if (aiCommandErrorKey) {
                    <div class="ai-command-menu__state ai-command-menu__state--error rounded-[12px] px-3 py-2 text-[12px] font-semibold">
                      {{ aiCommandErrorKey | t }}
                      @if (aiCommandErrorMessage) {
                        <span class="mt-1 block text-[11px] font-medium leading-4">{{ aiCommandErrorMessage }}</span>
                      }
                    </div>
                  }

                  @if (aiCommandMessages.length > 0) {
                    <div class="ai-command-thread">
                      @for (message of aiCommandMessages; track message.id) {
                        <article class="ai-command-message" [class.ai-command-message--user]="message.role === 'user'">
                          <div class="ai-command-message__meta">
                            <strong>{{ aiMessageTitle(message) }}</strong>
                            @if (message.result?.confidence !== null && message.result?.confidence !== undefined) {
                              <span class="ai-command-result__confidence rounded-full px-2 py-1 text-[11px] font-bold">
                                {{ message.result?.confidence | percent:'1.0-0' }}
                              </span>
                            }
                          </div>
                          <p>{{ message.text }}</p>
                          @if (hasAiMissingDetails(message.result ?? null)) {
                            <div class="ai-command-missing">
                              <strong>{{ aiMissingDetailsPrompt(message.result ?? null) }}</strong>
                              @if (aiReferenceOptionsLoading) {
                                <span class="ai-command-missing__state">{{ 'header.ai.loadingOptions' | t:'Loading options...' }}</span>
                              }
                              @if (aiReferenceOptionsErrorKey) {
                                <span class="ai-command-missing__state ai-command-missing__state--error">{{ aiReferenceOptionsErrorKey | t:'Unable to load options.' }}</span>
                              }

                              @if (hasAiMissingAlias(message.result ?? null, 'property')) {
                                <label class="ai-command-missing__field">
                                  <span>{{ 'aiDraft.field.property' | t:'Property' }}</span>
                                  <select
                                    [value]="aiDraftReferenceValue(message.result ?? null, 'propertyId')"
                                    [disabled]="aiReferenceOptionsLoading"
                                    (change)="resolveAiMissingReference(message.result ?? null, 'propertyId', $any($event.target).value)"
                                  >
                                    <option value="">{{ 'aiDraft.selectProperty' | t:'Select property' }}</option>
                                    @for (property of aiPropertyOptions; track property.id) {
                                      <option [value]="property.id">{{ aiPropertyLabel(property) }} · {{ aiPropertySubLabel(property) }}</option>
                                    }
                                  </select>
                                </label>
                              }

                              @if (hasAiMissingAlias(message.result ?? null, 'unit')) {
                                <label class="ai-command-missing__field">
                                  <span>{{ 'aiDraft.field.unit' | t:'Unit' }}</span>
                                  <select
                                    [value]="aiDraftReferenceValue(message.result ?? null, 'unitId')"
                                    [disabled]="aiReferenceOptionsLoading || !aiDraftReferenceValue(message.result ?? null, 'propertyId')"
                                    (change)="resolveAiMissingReference(message.result ?? null, 'unitId', $any($event.target).value)"
                                  >
                                    <option value="">{{ aiDraftReferenceValue(message.result ?? null, 'propertyId') ? ('aiDraft.selectUnit' | t:'Select unit') : ('aiDraft.selectPropertyFirst' | t:'Select property first') }}</option>
                                    @for (unit of aiUnitOptions; track unit.id) {
                                      <option [value]="unit.id">{{ aiUnitLabel(unit) }} · {{ aiUnitSubLabel(unit) }}</option>
                                    }
                                  </select>
                                </label>
                              }

                              @if (hasAiMissingAlias(message.result ?? null, 'tenant')) {
                                <label class="ai-command-missing__field">
                                  <span>{{ 'aiDraft.field.tenant' | t:'Tenant' }}</span>
                                  <select
                                    [value]="aiDraftReferenceValue(message.result ?? null, 'tenantId')"
                                    [disabled]="aiReferenceOptionsLoading"
                                    (change)="resolveAiMissingReference(message.result ?? null, 'tenantId', $any($event.target).value)"
                                  >
                                    <option value="">{{ 'aiDraft.selectTenant' | t:'Select tenant' }}</option>
                                    @for (tenant of aiTenantOptions; track tenant.id) {
                                      <option [value]="tenant.id">{{ aiTenantLabel(tenant) }} · {{ aiTenantSubLabel(tenant) }}</option>
                                    }
                                  </select>
                                </label>
                              }
                            </div>
                          }
                          @if (aiDraftQuestions(message.result ?? null).length) {
                            <div class="ai-command-intake">
                              @for (question of aiDraftQuestions(message.result ?? null); track question.field) {
                                @if (shouldShowAiDraftQuestion(message.result ?? null, question)) {
                                  <label class="ai-command-intake__field">
                                    <span class="ai-command-intake__label">
                                      <span>{{ question.label || question.field }}</span>
                                      <em [class.ai-command-intake__badge--required]="question.required">
                                        {{ question.required ? ('aiDraft.required' | t:'Required') : ('aiDraft.optional' | t:'Optional') }}
                                      </em>
                                    </span>
                                    <small>{{ question.question || question.label }}</small>

                                    @switch (aiQuestionType(question)) {
                                      @case ('textarea') {
                                        <textarea
                                          rows="2"
                                          [placeholder]="question.question || ''"
                                          [value]="aiDraftQuestionValue(message.result ?? null, question)"
                                          (change)="resolveAiDraftQuestion(message.result ?? null, question, $any($event.target).value)"
                                        ></textarea>
                                      }
                                      @case ('select') {
                                        <select
                                          [value]="aiDraftQuestionValue(message.result ?? null, question)"
                                          (change)="resolveAiDraftQuestion(message.result ?? null, question, $any($event.target).value)"
                                        >
                                          <option value="">{{ 'aiDraft.select' | t:'Select' }}</option>
                                          @for (option of question.options ?? []; track option) {
                                            <option [value]="option">{{ option }}</option>
                                          }
                                        </select>
                                      }
                                      @case ('upload') {
                                        <div class="ai-command-upload">
                                          <input
                                            #aiDraftUpload
                                            type="file"
                                            [accept]="aiUploadAccept(question)"
                                            multiple
                                            (change)="resolveAiDraftUploadQuestion(message.result ?? null, question, $event)"
                                          />
                                          <button type="button" class="ai-command-upload__button" (click)="aiDraftUpload.click()">
                                            <span class="material-symbols-outlined" aria-hidden="true">upload_file</span>
                                            <span>{{ 'aiDraft.uploadFiles' | t:'Upload files' }}</span>
                                          </button>
                                          @if (aiDraftUploadNames(message.result ?? null, question).length) {
                                            <div class="ai-command-upload__files">
                                              @for (fileName of aiDraftUploadNames(message.result ?? null, question); track fileName) {
                                                <span>{{ fileName }}</span>
                                              }
                                            </div>
                                          } @else {
                                            <p>{{ 'aiDraft.uploadHint' | t:'Attach photos or files that help explain the request.' }}</p>
                                          }
                                        </div>
                                      }
                                      @case ('reference') {
                                        @switch (aiQuestionReferenceGroup(question)) {
                                          @case ('property') {
                                            <select
                                              [value]="aiDraftQuestionValue(message.result ?? null, question)"
                                              [disabled]="aiReferenceOptionsLoading"
                                              (change)="resolveAiDraftQuestion(message.result ?? null, question, $any($event.target).value)"
                                            >
                                              <option value="">{{ 'aiDraft.selectProperty' | t:'Select property' }}</option>
                                              @for (property of aiPropertyOptions; track property.id) {
                                                <option [value]="property.id">{{ aiPropertyLabel(property) }} · {{ aiPropertySubLabel(property) }}</option>
                                              }
                                            </select>
                                          }
                                          @case ('unit') {
                                            <select
                                              [value]="aiDraftQuestionValue(message.result ?? null, question)"
                                              [disabled]="aiReferenceOptionsLoading || !aiDraftReferenceValue(message.result ?? null, 'propertyId')"
                                              (change)="resolveAiDraftQuestion(message.result ?? null, question, $any($event.target).value)"
                                            >
                                              <option value="">{{ aiDraftReferenceValue(message.result ?? null, 'propertyId') ? ('aiDraft.selectUnit' | t:'Select unit') : ('aiDraft.selectPropertyFirst' | t:'Select property first') }}</option>
                                              @for (unit of aiUnitOptions; track unit.id) {
                                                <option [value]="unit.id">{{ aiUnitLabel(unit) }} · {{ aiUnitSubLabel(unit) }}</option>
                                              }
                                            </select>
                                          }
                                          @case ('tenant') {
                                            <select
                                              [value]="aiDraftQuestionValue(message.result ?? null, question)"
                                              [disabled]="aiReferenceOptionsLoading"
                                              (change)="resolveAiDraftQuestion(message.result ?? null, question, $any($event.target).value)"
                                            >
                                              <option value="">{{ 'aiDraft.selectTenant' | t:'Select tenant' }}</option>
                                              @for (tenant of aiTenantOptions; track tenant.id) {
                                                <option [value]="tenant.id">{{ aiTenantLabel(tenant) }} · {{ aiTenantSubLabel(tenant) }}</option>
                                              }
                                            </select>
                                          }
                                          @default {
                                            <input
                                              type="text"
                                              [placeholder]="question.question || ''"
                                              [value]="aiDraftQuestionValue(message.result ?? null, question)"
                                              (change)="resolveAiDraftQuestion(message.result ?? null, question, $any($event.target).value)"
                                            />
                                          }
                                        }
                                      }
                                      @default {
                                        <input
                                          [type]="aiQuestionType(question) === 'number' ? 'number' : aiQuestionType(question) === 'date' ? 'date' : 'text'"
                                          [placeholder]="question.question || ''"
                                          [value]="aiDraftQuestionValue(message.result ?? null, question)"
                                          (change)="resolveAiDraftQuestion(message.result ?? null, question, $any($event.target).value)"
                                        />
                                      }
                                    }
                                  </label>
                                }
                              }
                            </div>
                          }
                          @if (isReviewableAiDraftResult(message.result ?? null)) {
                            <button
                              type="button"
                              class="ai-command-result__link mt-2 inline-flex cursor-pointer items-center gap-1 border-0 bg-transparent p-0 text-[12px] font-bold"
                              (click)="openAiDraftFromResult(message.result ?? null)"
                            >
                              {{ hasAiMissingDetails(message.result ?? null) ? ('header.ai.reviewPartialDraft' | t:'Review anyway') : ('header.ai.reviewDraft' | t) }}
                              <span class="material-symbols-outlined text-[16px] leading-none" aria-hidden="true">arrow_forward</span>
                            </button>
                          }
                          @if (message.role === 'assistant' && message.suggestions?.length) {
                            <div class="ai-command-followups">
                              @for (suggestion of message.suggestions; track suggestion) {
                                <button
                                  type="button"
                                  class="ai-command-followup"
                                  [disabled]="aiCommandLoading"
                                  (click)="useAiFollowUp(suggestion)"
                                >
                                  {{ suggestion }}
                                </button>
                              }
                            </div>
                          }
                        </article>
                      }
                      @if (aiCommandLoading) {
                        <div class="ai-command-message ai-command-message--loading">
                          <span class="ai-command-bar__spinner h-4 w-4 rounded-full border-2" aria-hidden="true"></span>
                          <span>{{ 'header.ai.thinking' | t }}</span>
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="ai-chat-empty">
                      <span class="ai-chat-empty__icon material-symbols-outlined" aria-hidden="true">forum</span>
                      <p>{{ 'header.ai.title' | t }}</p>
                      <span>{{ 'header.ai.subtitle' | t }}</span>
                    </div>

                    <div class="ai-chat-prompts">
                      @for (suggestion of aiCommandSuggestions; track suggestion.labelKey) {
                        <button
                          type="button"
                          class="ai-command-suggestion flex w-full cursor-pointer items-center gap-3 rounded-[12px] border-0 bg-transparent px-3 py-2.5 text-left"
                          (click)="useAiSuggestion(suggestion)"
                        >
                          <span class="ai-command-suggestion__icon grid h-9 w-9 shrink-0 place-items-center rounded-[10px]" aria-hidden="true">
                            <span class="material-symbols-outlined text-[19px] leading-none">{{ suggestion.icon }}</span>
                          </span>
                          <span class="min-w-0">
                            <span class="block text-[13px] font-semibold">{{ suggestion.labelKey | t }}</span>
                            <span class="block truncate text-[11px] leading-4">{{ suggestion.promptKey | t }}</span>
                          </span>
                        </button>
                      }
                    </div>
                  }
                </section>

                <aside class="ai-recent-drafts ai-chat-panel__drafts border-l px-3 py-3">
                  <div class="ai-recent-drafts__header">
                    <div>
                      <p>{{ 'header.ai.recentDrafts' | t }}</p>
                      <span>{{ 'header.ai.recentDraftsHint' | t }}</span>
                    </div>
                    <button
                      type="button"
                      class="ai-recent-drafts__refresh"
                      [disabled]="aiRecentDraftsLoading"
                      (click)="refreshAiRecentDrafts()"
                      [attr.aria-label]="'header.ai.refreshDrafts' | t"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true">refresh</span>
                    </button>
                  </div>

                  @if (aiRecentDraftsLoading) {
                    <div class="ai-recent-drafts__state">
                      <span class="ai-command-bar__spinner h-4 w-4 rounded-full border-2" aria-hidden="true"></span>
                      <span>{{ 'header.ai.loadingDrafts' | t }}</span>
                    </div>
                  } @else if (aiRecentDraftsErrorKey) {
                    <div class="ai-recent-drafts__state ai-recent-drafts__state--error">
                      {{ aiRecentDraftsErrorKey | t }}
                    </div>
                  } @else if (aiRecentDrafts.length === 0) {
                    <div class="ai-recent-drafts__state">
                      {{ 'header.ai.noRecentDrafts' | t }}
                    </div>
                  } @else {
                    <div class="ai-recent-drafts__list">
                      @for (draft of aiRecentDrafts; track draft.id) {
                        <div class="ai-recent-draft">
                          <button
                            type="button"
                            class="ai-recent-draft__main"
                            (click)="openAiDraftDrawer(draft.id, draft.organizationId)"
                          >
                            <span class="ai-recent-draft__icon material-symbols-outlined" aria-hidden="true">edit_note</span>
                            <span class="min-w-0">
                              <span class="ai-recent-draft__title">
                                {{ aiDraftIntentLabelKey(draft.intent) | t:aiDraftIntentFallback(draft.intent) }}
                              </span>
                              <span class="ai-recent-draft__summary">
                                {{ draft.summary || draft.prompt || ('header.ai.draftFallback' | t) }}
                              </span>
                              <span class="ai-recent-draft__status">
                                {{ needsAiExecutionReview(draft) ? ('header.ai.checkExecution' | t:'Check request status') : (aiDraftStatusLabelKey(draft.status) | t:aiDraftStatusFallback(draft.status)) }}
                              </span>
                            </span>
                          </button>
                          @if (!needsAiExecutionReview(draft)) {
                          <button
                            type="button"
                            class="ai-recent-draft__dismiss"
                            (click)="dismissAiRecentDraft($event, draft.id)"
                            [attr.aria-label]="'header.ai.dismissDraft' | t"
                          >
                            <span class="material-symbols-outlined" aria-hidden="true">close</span>
                          </button>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (aiDraftCursor) {
                    <apex-pagination mode="more" ariaLabel="More records" [loading]="aiRecentDraftsLoading" [moreLabel]="'header.ai.loadOlder' | t:'Load older drafts'" (loadMore)="loadAiRecentDrafts(true)" />
                  }
                </aside>
              </div>

              <form
                class="ai-chat-composer border-t p-3"
                (submit)="$event.preventDefault(); submitAiCommand()"
              >
                <span class="material-symbols-outlined" aria-hidden="true">auto_awesome</span>
                <input
                  type="text"
                  autocomplete="off"
                  [value]="aiCommandText"
                  [placeholder]="'header.ai.placeholder' | t"
                  (input)="updateAiCommandText($event)"
                />
                <button
                  type="submit"
                  [disabled]="aiCommandLoading || !aiCommandText.trim()"
                  [attr.aria-label]="'header.ai.submit' | t"
                >
                  @if (aiCommandLoading) {
                    <span class="ai-command-bar__spinner h-4 w-4 rounded-full border-2" aria-hidden="true"></span>
                  } @else {
                    <span class="material-symbols-outlined" aria-hidden="true">send</span>
                  }
                </button>
              </form>
            </div>
          }
        </div>

        @if (quickActions.length) {
        <div class="quick-actions" data-backoffice-quick-actions-menu>
          <button
            #quickActionsTrigger
            type="button"
            class="quick-actions-trigger"
            aria-haspopup="menu"
            aria-controls="backoffice-quick-actions"
            [attr.aria-label]="'header.quickActions' | t"
            [attr.title]="'header.quickActions' | t"
            [attr.aria-expanded]="quickActionsMenuOpen"
            (click)="toggleQuickActionsMenu()"
            (keydown.arrowdown)="openQuickActionsFromKeyboard($event)"
            (keydown.arrowup)="openQuickActionsFromKeyboard($event, true)"
          >
            <i class="pi pi-plus" aria-hidden="true"></i>
            <span class="quick-actions-trigger__label">{{ 'header.quickActions' | t }}</span>
            <i class="quick-actions-trigger__chevron pi pi-chevron-down" [class.rotate-180]="quickActionsMenuOpen" aria-hidden="true"></i>
          </button>

          @if (quickActionsMenuOpen) {
            <div
              #quickActionsMenu
              id="backoffice-quick-actions"
              class="quick-actions-menu"
              role="menu"
              [attr.aria-label]="'header.quickActions' | t"
              (keydown)="handleQuickActionsKeydown($event)"
            >
                @for (action of quickActions; track action.labelKey) {
                  <button
                    type="button"
                    class="quick-actions-menu__item"
                    role="menuitem"
                    tabindex="-1"
                    [disabled]="action.disabled"
                    [attr.aria-disabled]="action.disabled"
                    (click)="runQuickAction(action)"
                  >
                    <i class="pi" [ngClass]="action.icon" aria-hidden="true"></i>
                    <span>{{ action.labelKey | t }}</span>
                  </button>
                }
            </div>
          }
        </div>
        }
        <div class="relative" data-backoffice-notifications-menu>
          <button
            type="button"
            class="header-icon-button notifications-trigger"
            [attr.aria-label]="'header.notifications' | t"
            [attr.title]="'header.notifications' | t"
            [attr.aria-expanded]="notificationsMenuOpen"
            (click)="toggleNotificationsMenu()"
          >
            <i class="pi pi-bell" aria-hidden="true"></i>
            @if (unreadNotificationCount > 0) {
              <span class="absolute right-0.5 top-0.5 grid h-[16px] min-w-[16px] place-items-center rounded-full bg-[#F04438] px-1 text-[9px] font-bold leading-none text-white">
                {{ unreadNotificationCount > 99 ? '99+' : unreadNotificationCount }}
              </span>
            }
          </button>

          @if (notificationsMenuOpen) {
            <button
              type="button"
              class="fixed inset-0 z-40 cursor-default border-0 bg-transparent p-0"
              [attr.aria-label]="'header.closeNotifications' | t"
              (pointerdown)="closeNotificationsMenu($event)"
            ></button>
            <div class="notifications-menu absolute right-0 top-12 z-50 w-[min(360px,calc(100vw-32px))] overflow-hidden rounded-[14px] border border-[#EAECF0] bg-white shadow-xl">
              <div class="notifications-menu__header flex items-center justify-between border-b border-[#F2F4F7] px-4 py-3">
                <strong class="notifications-menu__title text-[14px] text-[#101828]">{{ 'header.notifications' | t }}</strong>
                @if (unreadNotificationCount > 0) {
                  <button type="button" class="notifications-menu__read-all cursor-pointer border-0 bg-transparent text-[12px] font-semibold text-[var(--workspace-primary)]" (click)="markAllNotificationsRead()">
                    {{ 'header.markAllNotificationsRead' | t }}
                  </button>
                }
              </div>
              @if (notificationsLoading) {
                <p class="notifications-menu__state m-0 px-4 py-5 text-[13px] text-[#667085]">{{ 'header.loadingNotifications' | t }}</p>
              } @else if (notifications.length === 0) {
                <p class="notifications-menu__state m-0 px-4 py-5 text-[13px] text-[#667085]">{{ 'header.noNotifications' | t }}</p>
              } @else {
                <div class="notifications-menu__list max-h-[420px] overflow-y-auto">
                  @for (notification of notifications; track notification.id) {
                    <button
                      type="button"
                      class="notifications-menu__item flex w-full cursor-pointer gap-3 border-0 border-b border-[#F2F4F7] px-4 py-3 text-left transition hover:bg-[#F8FCFE]"
                      [class.notifications-menu__item--unread]="!notification.read"
                      (click)="markNotificationRead(notification)"
                    >
                      <span class="notifications-menu__dot mt-1 h-2 w-2 shrink-0 rounded-full" [class.notifications-menu__dot--unread]="!notification.read"></span>
                      <span class="min-w-0">
                        <strong class="notifications-menu__item-title block text-[13px] text-[#101828]">{{ notificationTitle(notification) }}</strong>
                        <span class="notifications-menu__item-message mt-0.5 block text-[12px] leading-5 text-[#667085]">{{ notificationMessage(notification) }}</span>
                        <span class="notifications-menu__item-time mt-1 block text-[11px] text-[#98A2B3]">{{ notificationTimeLabel(notification) }}</span>
                      </span>
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>

        <button
          type="button"
          class="header-icon-button"
          [attr.aria-label]="colorSchemeLabel"
          [attr.title]="colorSchemeLabel"
          (click)="toggleColorScheme()"
        >
          <span class="material-symbols-outlined" aria-hidden="true">
            {{ colorSchemeIcon }}
          </span>
        </button>

        <button
          type="button"
          class="backoffice-header-avatar header-icon-button"
          [attr.aria-label]="'settings.profile' | t"
          [attr.title]="'settings.profile' | t"
          (click)="openProfile()"
        >
          @if (headerUser?.avatarUrl) {
            <img [src]="headerUser?.avatarUrl" alt="" class="h-full w-full object-cover" />
          } @else if (!headerUser?.identityLoaded) {
            <span class="place-self-center h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white"></span>
          } @else {
            <span class="place-self-center">{{ headerUser?.initials }}</span>
          }
        </button>
      </div>
    </header>

    @defer (when aiDraftDrawerOpen) {
      <app-ai-draft-review-drawer
        [open]="aiDraftDrawerOpen"
        [orgId]="activeAiDraftOrgId"
        [draftId]="activeAiDraftId"
        (closed)="closeAiDraftDrawer()"
      (draftChanged)="handleAiDraftChanged($event)"
      (draftLoaded)="handleAiDraftLoaded($event)"
      />
    }

    <div
      class="min-w-0 max-md:min-h-[calc(100dvh-76px)] lg:pt-[76px]"
      [class.backoffice-support-readonly-scope]="viewOnly"
    >
      @if (subscriptionViewOnly) {
        <section class="platform-support-banner subscription-view-only-banner" role="status" aria-live="polite">
          <span class="platform-support-banner__icon material-symbols-outlined" aria-hidden="true">lock_clock</span>
          <div class="platform-support-banner__body">
            <strong>Subscription ended · view only</strong>
            <span>
              You can still view and export everything in {{ workspaceName || 'this workspace' }}.
              {{ canRenewSubscription ? 'Renew to make changes again.' : 'Ask the workspace owner to renew it to make changes.' }}
            </span>
            @if (subscriptionViewOnlyNotice) {
              <small class="platform-support-banner__error">{{ subscriptionViewOnlyNotice }}</small>
            }
          </div>
          @if (canRenewSubscription) {
            <button type="button" class="platform-support-banner__end" (click)="renewSubscription()">Renew</button>
          }
        </section>
      }
      @if (platformSupportSession) {
        <section class="platform-support-banner" role="status" aria-live="polite">
          <span class="platform-support-banner__icon material-symbols-outlined" aria-hidden="true">admin_panel_settings</span>
          <div class="platform-support-banner__body">
            <strong>Platform support session active</strong>
            <span>
              {{ platformSupportAccessLabel }} access for {{ platformSupportSession.organizationName || workspaceName || 'this workspace' }} · {{ platformSupportExpiresLabel }}
            </span>
            @if (platformSupportSession.reason) {
              <small>{{ platformSupportSession.reason }}</small>
            }
            @if (platformSupportSessionError) {
              <small class="platform-support-banner__error">{{ platformSupportSessionError }}</small>
            }
          </div>
          <button
            type="button"
            class="platform-support-banner__end"
            [disabled]="platformSupportSessionEnding"
            (click)="endPlatformSupportSession()"
          >
            @if (platformSupportSessionEnding) {
              Ending...
            } @else {
              End session
            }
          </button>
        </section>
      }
      <app-plan-feature-feedback [organizationId]="activeWorkspaceId" [summary]="activeWorkspacePlan()" />
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<app-guide-spotlight />
